export type SrRoute =
  | "overview"
  | "approvals"
  | "anomalies"
  | "high-risk"
  | "blocks"
  | "dlp"
  | "ai-overview"
  | "ai-sessions"
  | "ai-spend"
  | "pr-risk"
  | "memory"
  | "audit"
  | "policy-packs"
  | "exceptions"
  | "ai-gateway";

export type SrGroup = "real-time" | "ai-usage" | "evidence" | "config";

export interface SrNavItem {
  id: SrRoute;
  label: string;
  group: SrGroup;
  /** Shown only to org admins; the page's controls are admin-only in Convex too. */
  adminOnly?: boolean;
}

export const SR_NAV: ReadonlyArray<SrNavItem> = [
  { id: "overview", label: "Overview", group: "real-time" },
  { id: "approvals", label: "Approvals", group: "real-time" },
  // The anomaly scan cron has been writing findings every 15 minutes with no
  // page to read them on. Grouped with the other real-time queues because that
  // is what it is: a live detector, not an after-the-fact record.
  { id: "anomalies", label: "Anomalies", group: "real-time" },
  { id: "high-risk", label: "High-risk sessions", group: "real-time" },
  { id: "blocks", label: "Blocks", group: "real-time" },
  { id: "dlp", label: "DLP", group: "real-time" },
  // AI usage (spec 2026-09-24 section 8.1): which AI the org uses, who uses
  // it, how much, and what Steerly can and cannot see.
  { id: "ai-overview", label: "AI overview", group: "ai-usage" },
  { id: "ai-sessions", label: "AI sessions", group: "ai-usage" },
  { id: "ai-spend", label: "AI spend", group: "ai-usage" },
  { id: "pr-risk", label: "PR risk", group: "evidence" },
  { id: "memory", label: "Memory graph", group: "evidence" },
  { id: "audit", label: "Audit log", group: "evidence" },
  { id: "policy-packs", label: "Policy packs", group: "config" },
  { id: "exceptions", label: "Exceptions", group: "config" },
  // The gateway's settings and controls. Convex refuses the gateway's health
  // read and its controls to anyone but an org admin; a member could read its
  // settings and tool statuses (with who and when left out), but the page is
  // for admins, and a member who opens #ai-gateway gets its admins-only message.
  { id: "ai-gateway", label: "AI gateway", group: "config", adminOnly: true },
];
